import React from 'react'
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import SectionTitle from './SectionTitle';
import {LinkOutIcon, LinkOutStyle} from 'components/static/icons'
import {Spacer} from 'layout/util'

const Section = styled.div`
	margin-top: 20px;
	margin-right: 20px;
	box-sizing: border-box;
	border-radius: 2px;
	font-size: 16px;
`;

const StyledLink = styled.a`
	font-family: ${props=>props.theme.fonts.h4};
	text-align: right;
	font-size: 14px;
	display: block;
	margin-top: 10px;
`;

const Author = StyledLink.withComponent('div');


const Endorsement = (props) => {
	const {quote, link, author} = props.data;
	const attribute = (!link || link==="") ? 
		<Author>{author}</Author>
	:
		<StyledLink href={link}>
			<LinkOutStyle><LinkOutIcon/></LinkOutStyle>
			{author}
		</StyledLink>;

	return(
		<Section>
			{quote}
			{attribute}
		</Section>
	);
}

const EndorsementBlock = (props) => {
	const {lovers, haters, title, subtitle, firstColTitle, secondColTitle} = props.data;
	const endorsements = lovers.map ( (lover,i) => (
			<Endorsement key={i} data={lover} />
	));
	const critics = haters.map ( (hater,i) => (
			<Endorsement key={i} data={hater} />
	));

	return(
		<div>
			<Row>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={1} sm={10} 
		      mdOffset={1} md={10} 
		      lgOffset={1} lg={10}
		    >
		    	<Spacer height={30}/>
					<SectionTitle title={title} subtitle={subtitle}/>
				</Col>
			</Row>

			<Spacer height={30}/>
			<Row>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={2} sm={8} 
		      mdOffset={2} md={4} 
		      lgOffset={2} lg={4}
		    >
			    <h3>{firstColTitle ? firstColTitle: "Lovers"}</h3>
					{endorsements}
				</Col>

		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={2} sm={8} 
		      mdOffset={0} md={4} 
		      lgOffset={0} lg={4}
		    >
			    <h3>{secondColTitle ? secondColTitle: "Haters"}</h3>
					{critics}
		    </Col>
			</Row>
		</div>
	)
}

export default EndorsementBlock;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/EndorsementBlock.js